import { fromJS, Map } from 'immutable';

import { openModal, closeModal, disableModal, enableModal, clearModal } from './actions';

export const defaultState = Map({
  modalProps: null,
  disabled: false,
  visible: false
});

export default function modal(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case openModal.type:
      return newState.set('modalProps', action.payload).set('visible', true);

    case closeModal.type:
      return newState.set('visible', false);

    case clearModal.type:
      return newState.set('modalProps', null);

    case disableModal.type:
      return newState.set('disabled', true);

    case enableModal.type:
      return newState.set('disabled', false);

    default:
      return newState;
  }
}

export const modalProps = state => state.modal.get('modalProps');
export const disabled = state => state.modal.get('disabled');
export const visible = state => state.modal.get('visible');
